import Vue from "vue";
import Router from "vue-router";
import routes from "../app/router";
import store from "../store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: routes
});

// Disable routes by unathenticated users
router.beforeEach((to, from, next) => {
  if (to.meta.authenticate && !store.getters.isAuthenticated) {
    next({ name: "Login", query: { from: window.location.pathname } });
  } else {
    next();
  }
});

export default router;
